export default "__VITE_ASSET__8596949d__"